import { Button } from 'antd'
import BaseTag from 'components/elements/BaseTag'
import { TUserActivityEmailLog } from 'features/leads/types'
import useAppControl from 'hooks/useAppControl'
import { FC } from 'react'

const ActivityEmailActions: FC<{
 datas?: TUserActivityEmailLog
 onClickReOrFor?: () => void
 showStatus?: boolean
}> = ({ datas, onClickReOrFor, showStatus = true }) => {
 const { updateSendEmailWidget } = useAppControl()

 const onClickMail = (
  val: 'REPLY' | 'FORWARD',
  data?: TUserActivityEmailLog,
 ): void => {
  updateSendEmailWidget({
   replyData: {
    date: data?.updated_at,
    subject: `${!data?.subject?.startsWith('Re:') ? 'Re: ' : ''}${
     data?.subject
    }`,
    to:
     data?.send_type === 'Send' || data?.send_type === 'send'
      ? data?.to_mail
      : data?.from_mail,
    toName: data?.from_name,
    body: data?.body,
    cc_email: data?.cc_email,
   },
   forwardData: {
    body: data?.body,
    from: data?.from_mail,
    subject: `${!data?.subject?.startsWith('Fwd:') ? 'Fwd: ' : ''} ${
     data?.subject
    }`,
    to: data?.to_mail,
    date: data?.updated_at,
    fromName: data?.from_name,
    toName: data?.to_name,
    attachment: data?.attachment,
    cc_email: data?.cc_email,
   },
   show: true,
   mode: val,
   widgetFrom: 'lead',
  })
  onClickReOrFor?.()
 }
 return (
  <div className="d-flex justify-content-end">
   {showStatus && datas?.status && (
    <div className="d-flex justify-content-end">
     <BaseTag
      tooltiOptions={{ overlayStyle: { maxWidth: '450px' } }}
      showTooltip={datas?.error_message !== null}
      tooltipContent={datas?.error_message}
      label={datas?.status}
      color={datas?.error_message ? 'red' : 'blue'}
     />
    </div>
   )}
   <Button
    size="small"
    onClick={() => {
     onClickMail('REPLY', datas)
    }}
    className="reply-i me-1"
    title="Reply"
   >
    <i className="far fa-reply" />
   </Button>
   <Button
    size="small"
    style={{ marginRight: '5px' }}
    onClick={() => {
     onClickMail('FORWARD', datas)
    }}
    title="Forward"
    className="forward-i"
   >
    <i className="far fa-share" />
   </Button>
  </div>
 )
}

export default ActivityEmailActions
